import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../../context/GlobalContext';

import ClaimCardButton from '../ClaimCardButton/ClaimCardButton';
import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';

import { installmentCustomerEligibility } from '../../../api/api';
import ErrorModal from '../../ErrorModal/ErrorModal';

import './DeviceClaim.scss';

interface Props {
    handleHeaderCancel: () => void;
}

const win: any = window;
const serverURL = win['base_portal_url'];
const errorPage = win['errorPageURL'];

function DeviceClaim({ handleHeaderCancel }: Props) {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, promotionData, raqiPromotion, wajidPromotion, deviceFlow, packageEligibility, customerAccount, msisdn } = state;

    const [notEligible, setNotEligible] = useState(false);
    const installmentPlans = packageEligibility?.deviceInstallmentPromotions ? packageEligibility?.deviceInstallmentPromotions : [];

    const { t } = useTranslation();

    const handleClaim = (value: string) => {
        const appliedPromo = promotionData?.filter((item: any) => {
            return item.name === value;
        })[0];
        const promoObj = appliedPromo?.metaExtension?.dataSet[0]?.genericData?.valueSet;
        const promoTypeCode = promoObj?.promoTypeCode ? promoObj?.promoTypeCode : "";
        const promoTypeValueEn = promoObj?.promoTypeValueEN ? promoObj?.promoTypeValueEN : "";
        const promoTypeValueAr = promoObj?.promoTypeValueAR ? promoObj?.promoTypeValueAR : "";
        const promoTypeValue = rtl ? promoTypeValueAr : promoTypeValueEn;
        const promoPeriod = promoObj?.commitmentPeriod;
        const promoAmount = appliedPromo?.action[0]?.actionValue;
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceTermsNCondition" } })
        dispatch({ type: 'PROMOTION_APPLIED', payload: { promotionApplied: appliedPromo, promoTypeCode: promoTypeCode, promoTypeValue: promoTypeValue, promoPeriod, promoAmount } })
    }

    const handleInstallmentClaim = (value: string) => {
        dispatch({ type: "LOADER", payload: { loading: true } });
        const whitelistFlag = packageEligibility?.whitelistFlag ? packageEligibility?.whitelistFlag : "";
        const appliedInstallment = installmentPlans?.filter((item: any) => {
            return item.PromotionTechnicalName === value;
        })[0];

        dispatch({ type: 'APPLIED_INSTALLMENT', payload: { appliedInstallment: appliedInstallment } })
        let monthlyAmount = appliedInstallment?.MonthlyCommitmentAmt ? appliedInstallment?.MonthlyCommitmentAmt : "";
        installmentCustomerEligibilityAPI(whitelistFlag, monthlyAmount);
    }

    const installmentCustomerEligibilityAPI = (whitelistFlag: string, monthlyAmount: string) => {
        const sanNum = customerAccount?.ServiceAccountNumber ? customerAccount?.ServiceAccountNumber : "";
        const reqInst = {
            msisdn: msisdn.replace('0', '966'),
            san: sanNum,
            whitelistFlagVal: whitelistFlag,
            monthlyAmount: monthlyAmount
        }
        installmentCustomerEligibility(reqInst)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    if (res.data?.status?.code === "CEM_0000") {
                        if (res.data?.eligibleForInstallment === "Yes") {
                            dispatch({ type: "LOADER", payload: { loading: false } });
                            dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceTermsNCondition" } })
                        } else {
                            dispatch({ type: "LOADER", payload: { loading: false } });
                            setNotEligible(true);
                        }
                    } else {
                        window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                    }
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            })
    }

    const handleNotEliglible = () => {
        setNotEligible(false);
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceLogin" } })
    }

    return (
        <>
            <HeaderNavigation
                rtl={rtl}
                percent={75}
                showBackArrow={false}
                handleHeaderCancel={handleHeaderCancel}
            />
            <div className='Subsidy__Plans'>
                <div className='SCP__headerText'>
                    <Typography rtl={rtl} id="lineType-heading" className='SCP__heading'>{deviceFlow === 'subsidy' ? t('Available_subsidy') : t('your_availble_insatallments')}</Typography>
                    <Typography rtl={rtl} id="lineType-Subheading" className='SCP__subHeading'>{deviceFlow === 'subsidy' ? t('Eligible_plans_subsidy') : t('congratulations_installment_plan_eligible')}</Typography>
                    <Typography rtl={rtl} id="lineType-Subheading" className='SCP__subHeading'>{t('Option_Continue')}</Typography>
                </div>

                {deviceFlow === 'subsidy' ? promotionData?.length > 0 && (
                    promotionData
                        .sort((a: any, b: any) => a.metaExtension.dataSet[0].genericData.valueSet.sequence > b.metaExtension.dataSet[0].genericData.valueSet.sequence ? 1 : -1)
                        .map((item: any) => {
                            const promo = item.metaExtension.dataSet[0].genericData.valueSet
                            const commitmentPeriod = promo.commitmentPeriod;
                            const amount = item.action[0].actionValue;

                            if (raqiPromotion.length > 0) {
                                return (
                                    <ClaimCardButton
                                        rtl={rtl}
                                        key={item.id}
                                        amount={amount}
                                        handleClaim={handleClaim}
                                        commitmentPeriod={commitmentPeriod}
                                        claimPromo={item.name}
                                        claimButtonEnable={raqiPromotion.includes(item.name)}
                                    />
                                )
                            } else {
                                return wajidPromotion.map((wj: any) => {
                                    if (promo.promoName.includes(wj)) {
                                        return (
                                            <ClaimCardButton
                                                rtl={rtl}
                                                key={item.id}
                                                amount={amount}
                                                handleClaim={handleClaim}
                                                commitmentPeriod={commitmentPeriod}
                                                claimPromo={item.name}
                                                claimButtonEnable={true}
                                            />
                                        )
                                    }
                                })
                            }
                        })
                ) : (
                    installmentPlans.map((item: any, key: number) => {
                        return (
                            <ClaimCardButton
                                rtl={rtl}
                                key={key}
                                amount={item?.MonthlyCommitmentAmt}
                                handleClaim={handleInstallmentClaim}
                                commitmentPeriod={item?.PromotionCommitmentPeriod}
                                claimPromo={item?.PromotionTechnicalName}
                                claimButtonEnable={true}
                            />
                        )
                    })

                )}
                {notEligible && (
                    <ErrorModal
                        id={'not-a-mobily-number'}
                        rtl={rtl}
                        title={t('installment_plan_not_eligible')}
                        description={t('installment_Number_not_eligible')}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleNotEliglible}
                    />
                )}
            </div>
        </>
    )
}

export default DeviceClaim